import React from "react";
import DamageForms from "./DamageForms";

const AddDamageReport = () => {
    return( 
        <DamageForms type="Add" />
    )
}

export default AddDamageReport